import script from "./AddEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./AddEmailModal.vue?vue&type=style&index=0&id=822f7462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-822f7462"]])

export default __exports__